package com.steamstreet.vegasful.browser

import com.steamstreet.vegasful.html.components.SPINNER_SVG
import com.steamstreet.vegasful.html.components.iconSvg

/**
 * Raw inline-SVG markup for [id], or an empty string for an unknown id.
 *
 * This reads the one registry in `common/html` rather than keeping a client-side copy of it. The
 * copy it replaces held two icons out of the registry's sixteen, so any client code that asked for
 * one of the other fourteen got an empty string and drew nothing — the same silent failure that the
 * FontAwesome markup produced, arrived at a different way.
 */
fun clientIconSvg(id: String): String = iconSvg(id)

/**
 * A self-spinning loader, animated with SMIL so it needs no companion CSS
 * keyframes. Replaces the previous `fa-cog fa-spin` spinner.
 *
 * The markup itself lives in `common/html` so that the server-rendered spinner
 * and this one cannot drift apart; two loaders that spin at different speeds on
 * different pages is the kind of difference nobody notices until they do.
 */
fun spinnerSvg(): String = SPINNER_SVG
